import React from "react";
import './ResultsNoIMG.css';
import ContestMenu from "./ContestMenu";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import QueryAllContestResults from "./QueryAllContestResults/QueryAllContestResults";
import { useSearchParams } from 'react-router-dom';



    function GatsbyContestResultsNoIMGSource (props) {
        let ThisPageContest = ''; // Первое, что мы делаем - мы получаем из гет-запроса название конкурса и его дату.
    let ThisPageContestDate = '';
        if (typeof window !== 'undefined') {
            const [searchParams] = useSearchParams();
            ThisPageContest = searchParams.get('contest');
            ThisPageContestDate = searchParams.get('date');}

    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['','ElementMenuActive','','','','']} Active={1}>
            <main className="TraderAllArchive StandartPage">
                <div className="StandartIn">
                    <div className="ContestIndexTitle">Contest Archive</div>
                    <div className="ContestResultsNoIMGOut">
                        <ContestMenu lang={props.lang} data={props.data} MenuElements={['NoActiveElements','NoActiveElements','ActiveElements']}/>
                        <QueryAllContestResults lang={props.lang} ThisPageContest={ThisPageContest} ThisPageContestDate={ThisPageContestDate}/>
                    </div>
                </div>
            </main>
        </LayoutMain>

    )}

export default GatsbyContestResultsNoIMGSource